// src/services/api.js
import axios from 'axios';

// Make sure this points to your backend server running on port 5050
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050/api';

console.log('Using API URL:', API_URL); // Add this for debugging

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 10000
});


// Add logging to help debug API calls
apiClient.interceptors.request.use(request => {
  console.log('🚀 API Request:', request.method, request.url);
  return request;
});

apiClient.interceptors.response.use(
  response => {
    console.log('✅ API Response:', response.status, response.config.url);
    return response;
  },
  error => {
    console.error('❌ API Error:', 
      error.response?.status, 
      error.response?.data || error.message,
      'URL:', error.config?.url
    );
    return Promise.reject(error);
  }
);

export const api = {
  // Projects
  getProjects: async () => {
    try {
      const response = await apiClient.get('/projects');
      console.log('Projects from API:', response.data);
      return response.data.records || [];
    } catch (error) {
      console.warn('Error fetching projects:', error);
      return [];
    }
  },
  
  // Departments
  getDepartments: async () => {
    try {
      const response = await apiClient.get('/departments');
      console.log('Departments from API:', response.data);
      return response.data.records || [];
    } catch (error) {
      console.warn('Error fetching departments:', error);
      return [];
    }
  },
  
  // Tasks
  getTasks: async () => {
    try {
      const response = await apiClient.get('/tasks');
      console.log('Tasks from API:', response.data);
      return response.data.records || [];
    } catch (error) {
      console.warn('Error fetching tasks:', error);
      return [];
    }
  },
  
  // Team
  getTeam: async () => {
    try {
      const response = await apiClient.get('/team');
      console.log('Team from API:', response.data);
      return response.data.records || [];
    } catch (error) {
      console.warn('Error fetching team:', error);
      return [];
    }
  },
  
  // Milestones
  getMilestones: async () => {
    try {
      const response = await apiClient.get('/milestones');
      console.log('Milestones from API:', response.data);
      return response.data.records || [];
    } catch (error) {
      console.warn('Error fetching milestones:', error);
      return [];
    }
  },
  
  // Create task
  createTask: async (taskData) => {
    try {
      const response = await apiClient.post('/tasks', taskData);
      return response.data.records[0];
    } catch (error) {
      console.error('Error creating task:', error);
      throw error;
    }
  },
  
  // Update task
  updateTask: async (id, taskData) => {
    try {
    console.log('Updating task with data:', taskData);
    
    const response = await apiClient.patch(`/tasks/${id}`, taskData);
    
    // Log successful response
    console.log('Task update successful:', response.data);
    return response.data;
  } catch (error) {
    // Enhanced error logging
    console.error('Error updating task:', error);
    console.error('Error details:', error.response?.data);
    throw error; // Re-throw to let component handle it
  }
  }
};

export default api;